export default __webpack_public_path__ + "static/media/img-1.db1c1cee.jpg";